 import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const d = new Date();
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © and rights reserved by{" "}
          <Link to="#" target="_blank" rel="noreferrer">
            Bry Talent
          </Link>{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
